import { ISwedBankIntegrationItem } from 'redux/reducers/swedBank/types';

export type TTableStructureType =
	| 'string'
	| 'number'
	| 'date'
	| 'currency'
	| 'country'
	| 'boolean'
	| 'button'
	| 'buttons';

export type TSwedBankIntegrationStructure = {
	name: string;
	selector: keyof ISwedBankIntegrationItem;
	show: boolean;
	sortable: boolean;
	filterable: boolean;
	filter: string[][];
	colSpan: number;
	type: TTableStructureType;
	align: 'center' | 'left' | 'right';
	noName?: boolean;
};

export enum TypeOfDialog {
	MARK_AS_PROCESSED = 'Mark as Processed',
	NOT_AN_INVOICE_PAYMENT = 'Not an Invoice Payment',
	ATTACH_VAT_REIMBURSEMENT = 'Attach VAT Reimbursement',
}
